import { Component, OnInit, Output, EventEmitter, Attribute } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';
import * as dateUtil from 'src/app/common/utility/date-time.utility';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadProgressComponent } from 'src/app/shared/components/upload-progress/upload-progress.component';
import { ImageCropperComponent } from 'src/app/shared/components/image-cropper/image-cropper.component';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { forkJoin } from 'rxjs';
import { NgbActiveModal , NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.css']
})
export class UnitsComponent implements OnInit {
  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  @Output() formChange: EventEmitter<boolean> = new EventEmitter();
  propertyForm: FormGroup;
  selectedProperty: any;
  selectedCountry: any = {};
  selectedModule: any = {};
  selectedCategory: any = {};
  selectedSubCategory: any = {};
  selectedMeasurement: any = {};
  buttonClicked:boolean = false;
  moduleList: Array<any> = [];
  categoryList: Array<any> = [];
  subCatList: Array<any> = [];
  baiscAttrList: Array<any> = [];
  avabhkList:Array<any> = [];
  categoryAttrList: Array<any> = [];
  attributeIds: any[] = [];
  attributePropertyIds: any[] = []
  countryList: Array<any> = [];
  measurementList: Array<any> = [];
  notValid:boolean = false;
  vendorDetails: any = {};
  basicAttrValues: any;
  currentDate = dateUtil.convertToPickerDate(new Date());
  propertyPreviewImage: string;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  onlyCountries = [];
  loadView: boolean = false;
  activeModel:NgbActiveModal;
  selectedISOCountry;
  valid:boolean = false;
  availableBhk:Array<any> = [
    {swatchName:'1', buttonStatus:'deactive',selected:false},
    {swatchName:'2', buttonStatus:'deactive', selected:false},
    {swatchName:'3', buttonStatus:'deactive', selected :false},
    {swatchName:'4', buttonStatus:'deactive', selected :false},
    {swatchName:'5', buttonStatus:'deactive', selected :false},
  ];

  titleProperties = [
    {
      id: 1,
      name: 'BEDROOM',
      value: ''
    },
    {
      id: 2,
      name: 'CATEGORY_TYPE',
      value: ''
    },
    {
      id: 3,
      name: 'PROPERTY_TYPE',
      value: ''
    },
    {
      id: 4,
      name: 'MODULE',
      value: ''
    },
    {
      id: 5,
      name: 'LOCATION',
      value: ''
    }
  ];
  firstLoad: boolean = false;
  isFormDirty: boolean = false;
  constructor(
    private fb: FormBuilder,
    private lookupModel: RsbLookupModel,
    private rsbService: RsbService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.firstLoad = true;
    this.selectedProperty = this.lookupModel.getVendorProperty() ? this.lookupModel.getVendorProperty() : null;
    if (!this.selectedProperty.vendorDetails || !this.selectedProperty.vendorDetails.twoDigitCountryCode) {
      this.selectedISOCountry = this.findCountryIso(this.lookupModel.getLoggedUser().personalDetails.twoDigitCountryCode);
    } else {
      this.selectedISOCountry = this.findCountryIso(this.selectedProperty.vendorDetails.twoDigitCountryCode);
    }
    this.onlyCountries = [this.selectedISOCountry];
    if(this.selectedProperty.basicAttributePropertyId) {
      this.attributePropertyIds = this.selectedProperty.basicAttributePropertyId;
    }
    if (!this.selectedProperty.vendorDetails) {
      this.vendorDetails = {
        name: this.lookupModel.getLoggedUser().personalDetails.firstName,
        email: this.lookupModel.getLoggedUser().personalDetails.email,
        countryCode: this.lookupModel.getLoggedUser().personalDetails.countryCode,
        whatsappcountryCode: this.lookupModel.getLoggedUser().personalDetails.countryCode,
        mobileNumber: this.lookupModel.getLoggedUser().personalDetails.mobile,
        wmobileNumber:''
      }
      this.selectedProperty['vendorDetails'] = this.vendorDetails;
    }

    this.selectedCountry = this.lookupModel.getPropertyCountry() ? this.lookupModel.getPropertyCountry() : {};
    this.selectedModule = this.lookupModel.getModule();
    // this.propertyPreviewImage = this.selectedProperty && this.selectedProperty.propertyPreviewImage ? this.selectedProperty.propertyPreviewImage : '';
    this.propertyForm = this.fb.group({
      moduleId: [this.selectedProperty.moduleId ? this.selectedProperty.moduleId : this.selectedModule.moduleId, [Validators.required]],
      categoryId: [this.selectedProperty.categoryId ? this.selectedProperty.categoryId : '', [Validators.required]],
      subCategoryId: [this.selectedProperty.subCategoryId ? this.selectedProperty.subCategoryId : '', [Validators.required]],
      basicAttributes: this.fb.array([]),
      categoryAttributes: this.fb.array([]),
      measurement: [this.selectedProperty.measurementId ? this.selectedProperty.measurementId : this.selectedSubCategory.measurementId,[Validators.required]],
      price:[this.selectedProperty.priceMin ? this.selectedProperty.priceMin : '',[Validators.required]],
      propertySize: [this.selectedProperty.propertySize ? this.selectedProperty.propertySize : '', [Validators.required]],
      projectDescription: [this.selectedProperty.projectDescription ? this.selectedProperty.projectDescription : ''],
      
    });
    // this.changeModuleFields(true);
    // this.formChanges();
    // this.getModules();
    // this.getMeasurementList();
    this.loadDetails();
    this.getCountryList();
  }

  checkReadOnly(): boolean {
    const readonly: boolean = this.selectedProperty && ([1, 2, 3].includes(this.selectedProperty.status));
    return readonly;
  }


  selectAttribute(prop: any, attributeProperties: Array<any>, attribute: any) {
    const obj = {};
    if (attribute.displayType === 1 || attribute.displayType === 3) {
      if (prop.selected && prop.selected === true) {
        prop.selected = false
      } else {
        attributeProperties.map((obj, index) => {
          if (obj.selected === true) {
            obj.selected = false
          }
        })
        obj["attributeId"] = attribute.attributeId;
        obj["attrValue"] = prop.attributePropertyId
        prop.selected = true;
      }
    } else {
      if (prop.selected && prop.selected === true) {
        prop.selected = false;
      } else {
        prop.selected = true;
      }
   
    }
    // const values:Array<any> = this.basicAttributess.controls.map(control => control.value);
    // values.map((obj) => {
    //    if(obj.attributeId === attribute.attributeId) {
    //       obj.attrValue = prop.propertyId
    //    }
    // })

    // const controlArray = this.basicAttributess as FormArray;
  }

  get basicAttributess(): FormArray {
    return this.propertyForm.get('basicAttributes') as FormArray;
  }
  filterBasicPropertyId(): any[] {
    this.attributePropertyIds = [];
    this.baiscAttrList.forEach(prop => {
      if (prop.displayType != 4) {
        prop.attributeProperties.forEach(prop1 => {
          if (prop1.selected === true) {
            this.attributeIds.push(prop?.attributeId);
            this.attributePropertyIds.push(prop1.propertyId);
          }

        });
      }
    })
    return this.attributePropertyIds;
  }
 
  prepareActiveButton(basicAttrListt: Array<any>): void {
    this.attributeIds = [];
    let attId;
    basicAttrListt.forEach(prop => {
      this.attributeIds.push(prop.attributeId);
      if(prop.displayType === 1 || prop.displayType === 2 || prop.displayType === 3) {
      prop.attributeProperties.forEach(prop1 => {
        attId = prop1.propertyId;
        const index = this.attributePropertyIds.findIndex((prop2) => prop2 === attId);
        if (index != -1) {
          prop1.selected= true;
        } else {
          prop1.selected = false;
        }
      
      });
    }
    })


  }
  changeMeasurement(measurement:any) {
    this.selectedMeasurement = measurement;
    this.measurementList.map((obj,index) => {
      if(obj.measurementId === measurement.measurementId) {
        obj["selected"] = true;
      } else {
        obj["selected"] = false;
      }
    })
  }
  onChangeModule(module:any) {
    this.selectedModule = module
    this.moduleList.map((obj,index) => {
      if(obj.moduleId === module.moduleId) {
        obj["selected"] = true
      } else {
        obj["selected"] = false;
      }
    })
    this.propertyForm.controls['moduleId'].setValue(module.moduleId)
  }

  isvalidAttr(attributeId) {
    const ind = this.baiscAttrList.findIndex((prop) => prop.attributeId === attributeId);
    const index = this.baiscAttrList[ind].attributeProperties.findIndex((prop1) => prop1.selected && prop1.selected == true);
    if (index === -1) {
      this.valid = false;
      return false;

    } else {
      this.valid = true;
      return true;
    }

  }
  changeCategory(category:any) {
    this.selectedCategory = category
    this.categoryList.map((obj,index) => {
      if(obj.categoryId === category.categoryId) {
        obj["selected"] = true
        this.subCatList = obj.subCategory
      } else {
        obj["selected"] = false
      }
    })
    this.propertyForm.controls['categoryId'].setValue(category.categoryId);
    
  }

  changeSubCategory(subCategory: any) {
    this.selectedSubCategory = subCategory;
    this.subCatList.map((obj, index) => {
      if (obj.subCategoryId === subCategory.subCategoryId) {
        obj["selected"] = true
      } else {
        obj["selected"] = false
      }
    })
    this.propertyForm.controls['subCategoryId'].setValue(subCategory.subCategoryId);
    this.attributePropertyIds = [];
    this.loadAttributes(subCategory.subcategoryId);
  }

  disableForm(): void {
    this.propertyForm.disable({emitEvent: false});
    this.propertySizeMax.enable();
    //this.dateAvailable.enable();
    this.whatsAppNumber.enable();
  }

  findCountryIso(key: string): string {
    let isoKey = Object.keys(CountryISO).find(item => CountryISO[item] === key.toLowerCase());
    if (isoKey) {
      return CountryISO[isoKey];
    }
  }

  loadDetails(): void {
    const forkJoins = forkJoin({
      sourceOne: this.rsbService.getActiveModulesForPostProperty(this.moduleId.value, this.selectedCountry.codeId,this.lookupModel.getLoggedUser().vendorTypeId),
      sourceTwo: this.rsbService.getActiveCategories(this.moduleId.value),
      sourceThree: this.rsbService.getActiveMeasurements(),
    });
    forkJoins.subscribe((rsp) => {
      if(rsp.sourceOne && rsp.sourceOne.statusCode === 0 && rsp.sourceOne.contents) {
        this.moduleList = rsp.sourceOne.contents;
        this.selectedModule = this.moduleList.find(item => item.moduleId === this.moduleId.value);
        // this.getCategories(this.moduleId.value);
        // this.changeModuleFields(true);
      }
      if(rsp.sourceTwo && rsp.sourceTwo.statusCode === 0 && rsp.sourceTwo.contents) {
        this.categoryList = rsp.sourceTwo.contents;
        this.categoryId.reset();
        this.subCategoryId.reset();
        this.subCategoryId.setValue('');
        if (this.selectedProperty && this.selectedProperty.listingId) {
          let category: any = this.categoryList.filter((cat) => cat.categoryId === this.selectedProperty.categoryId);
          this.selectedCategory = category[0];
          this.subCatList = category[0].subCategory;
          this.selectedSubCategory = this.subCatList.filter((subcat) => subcat.subCategoryId === this.selectedProperty.subCategoryId)[0];
          this.selectedMeasurement = this.selectedSubCategory;
          this.categoryId.setValue(this.selectedProperty.categoryId);
          this.subCategoryId.setValue(this.selectedProperty.subCategoryId);
          this.loadAttributes(this.selectedProperty.subCategoryId);
          if(this.checkReadOnly()) {
            this.disableForm();
          }
        } else {
          this.propertyForm.removeControl('basicAttributes');
          this.propertyForm.addControl('basicAttributes', new FormArray([]));
          this.firstLoad = false;
        }
      }
      if(rsp.sourceThree && rsp.sourceThree.statusCode === 0 && rsp.sourceThree.contents) {
        this.measurementList = rsp.sourceThree.contents;
        if (!this.measurement.value) {
          this.measurement.setValue(this.measurementList[0].measurementId);
        }
      }
      if(!this.firstLoad) {
        this.formChanges();
      }
    });
  }

  getModules(): void {
    this.rsbService.getActiveModules(this.moduleId.value, this.selectedCountry.codeId).subscribe((rsp) => {
      if (rsp.statusCode === 0 && rsp.contents) {
        this.moduleList = rsp.contents;
        this.selectedModule = this.moduleList.find(item => item.moduleId === this.moduleId.value);
        this.getCategories(this.moduleId.value);
        // this.changeModuleFields(true);
      }
    });
  }

  getCategories(moduleId: string): void {
    this.rsbService.getActiveCategories(moduleId).subscribe((rsp) => {
      if (rsp.statusCode === 0 && rsp.contents) {
        this.categoryList = rsp.contents;
        this.categoryId.reset();
        this.subCategoryId.reset();
        this.subCategoryId.setValue('');
        if (this.selectedProperty && this.selectedProperty.listingId) {
          let category: any = this.categoryList.filter((cat) => cat.categoryId === this.selectedProperty.categoryId);
          this.selectedCategory = category[0];
          this.subCatList = category[0].subCategory;
          this.selectedSubCategory = this.subCatList.filter((subcat) => subcat.subCategoryId === this.selectedProperty.subCategoryId)[0];
          this.selectedMeasurement = this.selectedSubCategory;
          this.categoryId.setValue(this.selectedProperty.categoryId);
          this.subCategoryId.setValue(this.selectedProperty.subCategoryId);
          if(this.checkReadOnly()) {
            this.disableForm();
          }
        } else {
          this.propertyForm.removeControl('basicAttributes');
          this.propertyForm.addControl('basicAttributes', new FormArray([]));
          this.firstLoad = false;
        }
      }
    });
  }

  getCountryList(): void {
    this.countryList = this.lookupModel.getCountryList();
    // this.priceCurrency.disable();
    // this.depositCurrency.disable();
  }

  getMeasurementList(): void {
    this.rsbService.getActiveMeasurements().subscribe((rsp) => {
      if (rsp.statusCode === 0 && rsp.contents) {
        this.measurementList = rsp.contents;
        if (!this.measurement.value) {
          this.measurement.setValue(this.measurementList[0].measurementId);
        }
      }
    });
    // this.measurement.disable();
  }

  prepareLocationText(propertyInfo: any): string {
    let locationText = '';
    if (propertyInfo.addressLine1) {
      locationText += propertyInfo.addressLine1 + ',';
    }

    if (propertyInfo.landmark) {
      locationText += propertyInfo.landmark + ',';
      const index = this.titleProperties.findIndex(item => item.name === 'LOCATION');
      this.titleProperties[index].value = propertyInfo.landmark + ', ';
    }

    if (propertyInfo.locality) {
      locationText += propertyInfo.locality + ',';
      const index = this.titleProperties.findIndex(item => item.name === 'LOCATION');
      this.titleProperties[index].value = this.titleProperties[index].value + propertyInfo.locality + ', ';
    }

    if (propertyInfo.city) {
      locationText += propertyInfo.city + ',';
      const index = this.titleProperties.findIndex(item => item.name === 'LOCATION');
      this.titleProperties[index].value = this.titleProperties[index].value + propertyInfo.city;
    }

    if (propertyInfo.countryName) {
      locationText += propertyInfo.countryName + ',';
    }

    if (propertyInfo.pincode) {
      locationText += propertyInfo.pincode;
    }
    return locationText;
  }

  preTitle(prop,index ) : void {
    this.availableBhk[index].selected = this.availableBhk[index].selected ? false : true
    this.availableBhk[index].buttonStatus =  this.availableBhk[index].buttonStatus ? 'active' : 'deactive';
  }

  validAttr() {
   const allBhk =  this.availableBhk.filter((obj)=> {
      return obj.selected === true
    })

    const val = allBhk.length ? true: false
    return val;
  }
  formChanges(): void {
    this.propertyForm.valueChanges.subscribe((val) => {
      // console.log('Property Form Value changes :: ', val);
      this.emitFormChanges(true);
    });

    this.moduleId.valueChanges.subscribe((val) => {
      if (val) {
        this.selectedModule = this.moduleList.find(item => item.moduleId === val);
        this.getCategories(val);
        // this.changeModuleFields(val);
        this.resetForm();
      }
    });

    this.categoryId.valueChanges.subscribe((val) => {
      if (val) {
        // this.loadAttributes(val);
        let category: any = this.categoryList.filter((cat) => cat.categoryId === val);
        this.selectedCategory = category[0];
        this.subCatList = category[0].subCategory;
        this.selectedSubCategory = null;
        if(this.selectedProperty && this.selectedProperty.listingId && this.firstLoad && val === this.selectedProperty.categoryId) {
          this.firstLoad = false;
        } else {
          this.resetForm();
        }
      }
    });

    this.subCategoryId.valueChanges.subscribe((val) => {
      if (val) {
        this.loadAttributes(val);
        this.selectedSubCategory = this.subCatList.filter((subcat) => subcat.subCategoryId === val)[0];
        this.selectedMeasurement = this.selectedSubCategory;
        this.measurement.setValue(this.selectedMeasurement.measurementId);
        this.prepareSeoTitle(!(this.selectedProperty && this.selectedProperty.listingId));
      }
    });

    this.measurement.valueChanges.subscribe((val) => {
      if(val) {
        const item = this.measurementList.find(item => item.measurementId === val);
        if(item) {
          this.selectedMeasurement = item;
          this.prepareSeoTitle(!(this.selectedProperty && this.selectedProperty.listingId));
        } else {
          this.selectedMeasurement = null;
        }
      } else {
        this.selectedMeasurement = null;
      }
    });
  }

  // changeModuleFields(fillValue?: boolean): void {
  //   if(this.selectedModule.moduleStatus === 2) {
  //     const pricePerValue = this.selectedProperty.pricePer && fillValue ? this.selectedProperty.pricePer : '';
  //     const projectNameValue = this.selectedProperty.projectName && fillValue ? this.selectedProperty.projectName : '';
  //     this.propertyForm.addControl('pricePer', new FormControl(pricePerValue, Validators.required));
  //     this.propertyForm.addControl('projectName', new FormControl(projectNameValue, Validators.required));
  //   } else {
  //     this.propertyForm.removeControl('pricePer');
  //     this.propertyForm.removeControl('projectName');
  //   }sub
  // }

  loadAttributes(val: string): void {
    if (this.selectedProperty.listingId && this.selectedProperty.subCategoryId && this.selectedProperty.subCategoryId === val) {
      this.rsbService.getCategoriesForEdit(this.selectedProperty.listingId, this.categoryId.value, val, this.moduleId.value).subscribe((rsp) => {
        if (rsp.statusCode === 0) {
          this.availableBhk =  rsp.basicAttributes.filter((obj) => {
            return obj.attributeName.toUpperCase() === 'BHK'
          })
          const list = {
            basicAttributes: rsp.basicAttributes.filter((obj) => {
              return obj.attributeName.toUpperCase() !== 'BHK'
            }),
            categoryAttributes: rsp.additionalAttributes.concat(rsp.specialAttributes)
          };
          
          if(this.selectedProperty.listingId === 'abc'){
          
            let basicAttr = this.lookupModel.getBasicValues();
            if(this.availableBhk.length) {
              this.prepareCategoryProperties(this.availableBhk, basicAttr);
            }
            this.prepareCategoryProperties(list, basicAttr);
          } else {
            if(this.availableBhk.length) {
              this.prepareCategoryProperties(this.availableBhk);
            }
            this.prepareCategoryProperties(list);
          }

          // this.mapAdditionalAttributes();

          if(this.firstLoad) {
            this.formChanges();
            this.firstLoad = false;
          }
        }
      });
    } else {
      this.rsbService.getAllPropertiesForCategories(this.categoryId.value, val, this.moduleId.value).subscribe((rsp) => {
        if (rsp.statusCode === 0 && rsp.contents) {
          const list = {
            basicAttributes: rsp.contents.basicAttributes,
            categoryAttributes: rsp.contents.categoryAttributes
          };
          this.prepareCategoryProperties(list);
        }
      });
    }
  }

  // prepareAttributeProperties(list: any, basicList?: any[]): void {
  //   const basicProp = this.propertyForm.get('avaBhk');
  //   if (basicProp) {
  //     this.propertyForm.removeControl('avaBhk');
  //     this.propertyForm.addControl('avaBhk', new FormArray([]));
  //   }
  //   this.avabhkList = list;
  
  //   if(this.avabhkList) {
  //     this.prepareBasicArray(this.avabhkList, basicList);
  //   } else {
  //     this.prepareBasicArray(this.avabhkList);
  //   }

  //   if(this.checkReadOnly()) {
  //     this.avaBhk.disable();
  //   }
  // }

  prepareCategoryProperties(list: any, basicList?: any[]): void {
    const basicProp = this.propertyForm.get('basicAttributes');
    if (basicProp) {
      this.propertyForm.removeControl('basicAttributes');
      this.propertyForm.addControl('basicAttributes', new FormArray([]));
    }
    console.log("basic attributesss is",list.basicAttributes);
    this.baiscAttrList = list.basicAttributes;
  
    if(basicList) {
      this.prepareActiveButton(this.baiscAttrList)
      this.prepareBasicArray(this.baiscAttrList, basicList);
    } else {
      this.prepareBasicArray(this.baiscAttrList);
    }

    let ctgrList = list.categoryAttributes;
    if (ctgrList) {
      this.categoryAttrList = ctgrList.sort((a, b) => a.order - b.order);
    } else {
      this.categoryAttrList = [];
    }
    this.lookupModel.setPropertyCategoryList(this.categoryAttrList);
    if(this.checkReadOnly()) {
      this.basicAttributes.disable();
    }
  }

  prepareBhkArray(basicAttrList: Array<any>, basicValueList?: any[]): void {
    const formProp = this.propertyForm.get('avabhk') as FormArray;
    if (basicAttrList) {
      basicAttrList.forEach(attr => {
  
        if (attr.attributeProperties && attr.attributeProperties.length) {
          let selectedProp;
          if(basicValueList && basicValueList.length > 0) {
            selectedProp = basicValueList.find(item => item.attributeId === attr.attributeId);
            selectedProp.propertyId = selectedProp.attrValue;
          } else {
            selectedProp = attr.attributeProperties?.find(prop => prop?.isSelected);
          }
          if (selectedProp) {
            formProp.push(this.createBasicGroup(attr.attributeId, selectedProp.propertyId,attr.required));
          } else {
            formProp.push(this.createBasicGroup(attr.attributeId,'',attr.required));
          }
        } 
      
      });
    }
  }

  prepareBasicArray(basicAttrList: Array<any>, basicValueList?: any[]): void {
    const formProp = this.propertyForm.get('basicAttributes') as FormArray;
    if (basicAttrList) {
      basicAttrList.forEach(attr => {
        if(attr.value) {
          formProp.push(this.createBasicGroup(attr.attributeId, attr.value,attr.required,attr.displayType));
        }
        else if (attr.attributeProperties && attr.attributeProperties.length) {
          let selectedProp;
          if(basicValueList && basicValueList.length > 0) {
            selectedProp = basicValueList.find(item => item.attributeId === attr.attributeId);
            selectedProp.propertyId = selectedProp.attrValue;
          } else {
            selectedProp = attr.attributeProperties?.find(prop => prop?.selected);
          }
          if (selectedProp) {
            formProp.push(this.createBasicGroup(attr.attributeId, selectedProp.propertyId,attr.required,attr.displayType));
          } else {
            formProp.push(this.createBasicGroup(attr.attributeId,'',attr.required,attr.displayType));
          }
        } else {
          formProp.push(this.createBasicGroup(attr.attributeId,'',attr.required,attr.displayType));
        }
      
      });
    }
  }

  createBasicGroup(attributeId: string, value?: any,required?:any,displayType?:number): FormGroup {
    let basicGroup: FormGroup;

    if (value) {
      if (required === 1 && displayType == 4) {
        basicGroup = this.fb.group({
          attributeId: attributeId,
          attrValue: [value, [Validators.required]]
        });
      } else {
        basicGroup = this.fb.group({
          attributeId: attributeId,
          attrValue: [value]
        });
      }
    } else {
      if (required === 1 && displayType == 4) {
        basicGroup = this.fb.group({
          attributeId: attributeId,
          attrValue: ['', [Validators.required]]
        });
      } else {
        basicGroup = this.fb.group({
          attributeId: attributeId,
          attrValue: ['']
        });
      }
    }
    return basicGroup;
  }

  changeLocation(): void {
    this.showNextPage.emit(1);
  }

  changeMeasurment(): void {
    this.measurement.enable();
  }

  // currencyChange(val: string): void {
  //   this.priceCurrency.setValue(val);
  //   this.depositCurrency.setValue(val);
  //   this.priceCurrency.disable();
  //   this.depositCurrency.disable();
  // }

  // changeCurrency(depositFlag?: boolean): void {
  //   if (depositFlag) {
  //     this.depositCurrency.enable();
  //   } else {
  //     this.priceCurrency.enable();
  //   }
  // }

  uploadAws(event: any): void {
    const mdlRef = this.modalService.open(ImageCropperComponent, { windowClass: 'signInForm'});
    mdlRef.componentInstance.imageChangedEvent = event;
    mdlRef.result.then((result) => {
      if(result) {
        const modalRef = this.modalService.open(UploadProgressComponent, { windowClass: 'signInForm' });
        modalRef.componentInstance.file = result;
        modalRef.result.then((rsp) => {
          if (rsp) {
            this.propertyPreviewImage = rsp;
          }
        });
      }
    });
  }

  prepareSeoTitle(setTitle: boolean = true): string {
    let str = '';
    let propChangeFlag = false;
    this.titleProperties.forEach(prop => {
      switch (prop.name) {
        case 'BEDROOM': {
          const bedRoom = this.baiscAttrList?.find(item => item.attributeName.toUpperCase() === 'BHK');
          if (bedRoom) {
            const selectedBedRoom = this.basicAttributes.value.find(item => item.attributeId === bedRoom.attributeId);
            let bedRoomProp;
            if (selectedBedRoom) {
              bedRoomProp = bedRoom.attributeProperties.find(item => item.propertyId === selectedBedRoom.attrValue);
            }
            if (bedRoomProp && bedRoomProp !== prop.value) {
              prop.value = bedRoomProp.swatchName;
              propChangeFlag = true;
            } else {
              return;
            }
            str = prop.value + ' BHK ';
          }
          break;
        }
       // case 'AREA': {
          // if(this.selectedCategory.categoryTypeStatus === 3) {
         // if (this.propertySize.value) {
           // prop.value = this.propertySize.value + ' ' + this.selectedMeasurement.measurementName + ' ';
           // str += prop.value;
          //}
          // }
          //break;
        //}
        //case 'FURNISHED': {
          //const furnished = this.baiscAttrList.find(item => item.attributeName.toUpperCase() === 'FURNISHED');
          //if (furnished) {
            //const selectedFurnished = this.basicAttributes.value.find(item => item.attributeId === furnished.attributeId);
            //let furnishedProp;
            //if (selectedFurnished) {
             // furnishedProp = furnished.attributeProperties.find(item => item.propertyId === selectedFurnished.attrValue);
           // }
            //if (furnishedProp && furnishedProp !== prop.value) {
             // prop.value = furnishedProp.swatchName;
             // propChangeFlag = true;
            //} else {
              //return;
            //}
            //str = str + ' ' + prop.value;
          //}
          //break;
        //}
        case 'CATEGORY_TYPE': {
          if (this.selectedCategory.categoryTypeStatus === 3) {
            str += this.selectedCategory.categoryName;
          }
          break;
        }
        case 'PROPERTY_TYPE': {
          prop.value = this.selectedSubCategory ? this.selectedSubCategory.subCategoryName : '';
          if (prop.value) {
            str = str + ' ' + prop.value;
          }
          break;
        }
        case 'MODULE': {
          // prop.value = 'Rent';
          prop.value = this.selectedModule.moduleHeading;
          if (prop.value) {
            str = str + ' for ' + prop.value + ' at';
          }
          break;
        }
        case 'LOCATION': {
          str = str + ' ' + prop.value;
          break;
        }
        default: {
          str = '';
          break;
        }
      }
    });
    // if(!this.propertyTitle.value || propChangeFlag) {
    // this.propertyTitle.setValue(str);
    // }
   
    return str;
  }

  checkAttributes(): boolean {
    this.baiscAttrList && this.baiscAttrList.map((obj) => {
       if(obj.required === 1 && obj.displayType != 4) {
       const ind =  obj.attributeProperties?.findIndex((obj1) => {
           return !obj1.selected || obj1.selected == false
        })

        if(ind > -1) {
          this.notValid = true
        } 
       }

    })
      return this.notValid
  }

  submit(formvalue: any): void {
    // formvalue.basicAttributes = this.basicAttributess.controls.map(control => control.value);
    // if(this.baiscAttrList.length) {
    // const returnattributeProp = this.filterBasicPropertyId() 
    // }
    if (this.propertyForm.invalid || !this.checkAttributes) {
      return;
    }
    
    const propertyInfo = this.lookupModel.getVendorProperty();
    const mobile = this.mobile.value;
    const e164Number = mobile.e164Number;
    const mobileNumber = e164Number.replace(mobile.dialCode, ''); 
    const wmobile = this.whatsAppNumber.value;
    if (propertyInfo.status === 2 || propertyInfo.status === 3) {
      propertyInfo.status = 1;
    } else {
      propertyInfo.status = propertyInfo.status ? propertyInfo.status : 0;
    }
    propertyInfo.moduleId = formvalue.moduleId;
    propertyInfo.categoryId = formvalue.categoryId;
    propertyInfo.subCategoryId = formvalue.subCategoryId;
    propertyInfo.price = formvalue.price;
   
    // propertyInfo.deposit = formvalue.deposit;

    propertyInfo.propertySize = formvalue.propertySize;
    // propertyInfo.dateAvailable = dateUtil.convertFromPickerDate(formvalue.dateAvailable);
    propertyInfo.propertyTitle = formvalue.propertyTitle;
    propertyInfo.propertyDescription = formvalue.propertyDescription;
    propertyInfo.vendorDetails = {
      name: this.name.value,
      email:this.email.value,
      countryCode: parseInt(mobile.dialCode),
      mobileNumber: mobileNumber,
      twoDigitCountryCode: mobile.countryCode,
      wcountryCode: parseInt(wmobile.dialCode),
      wmobileNumber: wmobile

    }
    // propertyInfo.propertyPreviewImage = this.propertyPreviewImage;
    propertyInfo.basicAttributeId = formvalue.basicAttributes.filter((obj) => { return obj.attrValue !='' }).map((obj1) => {return obj1.attributeId });
    propertyInfo.basicAttributePropertyId = formvalue.basicAttributes.filter((obj) => { return obj.attrValue !='' }).map((obj1) => {return obj1.attrValue });
    propertyInfo.basicAttributePropertyId = propertyInfo.basicAttributePropertyId.concat(this.filterBasicPropertyId());
    propertyInfo.basicAttributeId = propertyInfo.basicAttributeId.concat(this.attributeIds);
    propertyInfo.measurementId = this.measurement.value;
    // propertyInfo.priceTypeId = this.priceCurrency.value;
    propertyInfo.baiscAttrList = this.baiscAttrList;
    propertyInfo.seoTitle = this.prepareSeoTitle();
    if (this.selectedProperty.listingId && this.selectedProperty.listingId !== 'abc') {
      propertyInfo.listingId = this.selectedProperty.listingId;
    } else {
      propertyInfo.listingId = 'abc';
      this.lookupModel.setBasicValues(formvalue.basicAttributes);
    }

    // this.toletService.addUpdateListings(propertyInfo).subscribe((rsp) => {
    //   if (rsp.statusCode === 0) {
    //     if (rsp.contents.listingId) {
    //       propertyInfo.listingId = rsp.contents.listingId;

    //     }
    //     this.lookupModel.setLisStatus(rsp.contents.lisStatus);
    //     this.lookupModel.setVendorProperty(propertyInfo);
    //     this.showNextPage.emit(3);
    //   }
    // });

    this.lookupModel.setVendorProperty(propertyInfo);
    this.emitFormChanges(false);
    this.showNextPage.emit(3);
  }

  resetForm(): void {
    this.subCategoryId.reset();
    this.subCategoryId.setValue('');
    this.measurement.reset();
    this.propertySizeMin.reset();
    this.projectDescription.reset();
    // this.dateAvailable.reset();
    // this.propertyPreviewImage = '';
    this.propertyForm.removeControl('avaBhk');
    this.propertyForm.removeControl('basicAttributes');
    // this.propertyForm.reset();
    this.propertyForm.addControl('basicAttributes', new FormArray([]));
  }


  emitFormChanges(val: boolean): void {
    if(this.isFormDirty !== val) {
      this.isFormDirty = val;
      this.formChange.emit(val);
    }
  }

  isvalidSubCategoryAttr(attributeId) {
    const ind = this.baiscAttrList.findIndex((prop) => prop.attributeId === attributeId && prop.required === 1);
    
    if (ind >= 0) {
      if (!this.baiscAttrList[ind].value) {
        return false;

      } else {
        console.log("false is false")
        return true;
      }
    }

  }

  checkDateProperties(attributeId, date:NgbDateStruct) {

    const dateManager  = date.year +'-'+ date.month+'-'+ date.day;
    let ind = this.baiscAttrList.findIndex((obj) => {
      return obj.attributeId === attributeId
    })
    this.baiscAttrList[ind].value = dateManager;

  }

  checkProperties(attributeId, event) {

    
    let ind = this.baiscAttrList.findIndex((obj) => {
      return obj.attributeId === attributeId
    })
    
    this.baiscAttrList[ind].value = event.target.value;


  }

  get moduleId() { return this.propertyForm.get('moduleId'); }
  get measurement() { return this.propertyForm.get('measurement'); }
  get categoryId() { return this.propertyForm.get('categoryId'); }
  get subCategoryId() { return this.propertyForm.get('subCategoryId'); }
  //get price() { return this.propertyForm.get('price'); }
 // get deposit() { return this.propertyForm.get('deposit'); }
  get priceMin() { return this.propertyForm.get('priceMin'); }

  get projectName() { return this.propertyForm.get('projectName'); }

  //get pricePer() { return this.propertyForm.get('pricePer'); }

  get priceMax() { return this.propertyForm.get('priceMax'); }
  // get rentPayTypeId() { return this.propertyForm.get('rentPayTypeId'); }
  // get agentPayTypeId() { return this.propertyForm.get('agentPayTypeId'); }
  // get deposit() { return this.propertyForm.get('deposit'); }
  get propertySizeMin() { return this.propertyForm.get('propertySizeMin'); }

  get propertySizeMax() { return this.propertyForm.get('propertySizeMax'); }
  // get propertyTitle() { return this.propertyForm.get('propertyTitle'); }
  get projectDescription() { return this.propertyForm.get('projectDescription'); }
  get basicAttributes() { return this.propertyForm.get('basicAttributes'); } 
  get categoryAttributes() { return this.propertyForm.get('categoryAttributes'); }
  // get dateAvailable() { return this.propertyForm.get('dateAvailable'); }
  get name() { return this.propertyForm.get('name') }
  get email() { return this.propertyForm.get('email') }
  get mobile() { return this.propertyForm.get('mobile') }
  get whatsAppNumber() { return this.propertyForm.get('whatsAppNumber') }
}

